/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConcernedSubjectCreateDto } from './concernedSubjectCreateDto.model';
import { ToDtsrcSubjectKnCreateDto } from './toDtsrcSubjectKnCreateDto.model';
import { CreateToDtsrcLvDto } from './createToDtsrcLvDto.model';
import { ProjectRequestDto } from './projectRequestDto.model';
import { CreateToDtsrcParDto } from './createToDtsrcParDto.model';
import { ToDtsrcSubjectLpisCreateDto } from './toDtsrcSubjectLpisCreateDto.model';
import { CreateToDtsrcAreaDto } from './createToDtsrcAreaDto.model';


export interface CreateProjectAndToDtsrcDto { 
    areas?: Array<CreateToDtsrcAreaDto>;
    concernedSubjects?: Array<ConcernedSubjectCreateDto>;
    lvs?: Array<CreateToDtsrcLvDto>;
    pars?: Array<CreateToDtsrcParDto>;
    project?: ProjectRequestDto;
    subjectKns?: Array<ToDtsrcSubjectKnCreateDto>;
    subjectLpises?: Array<ToDtsrcSubjectLpisCreateDto>;
}

